import React from 'react'
import styled from 'styled-components'
import Papa from 'papaparse'
import {FaFileDownload} from 'react-icons/fa'
import { saveAs } from 'file-saver';

const CustomLink = styled.p`
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: bold;
  display: block;
  margin: 0 30px 25px 0;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.main};
    text-decoration: none;
    font-weight: bolder;
  }
  & > svg {
    margin-right: 10px;
    font-size: 20px;
  }
`

export default class ExportResultsButton extends React.PureComponent {
  downloadCsv = (result) => {

    const csv = Papa.unparse(result)
    let csvData = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], {type: 'text/csv;charset=utf-8;'})

    saveAs(csvData, "SurveyResults_" + (new Date()).toDateString() + ".csv");
  }

    render() {
    return (
      <CustomLink onClick={ () => this.downloadCsv( this.props.data ) } >
        <FaFileDownload />
        Download CSV
      </CustomLink>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/ExportResultsButton/ExportResultsButton.js